import { PhysicsShapeType, PhysicsUtils } from '../physics';
import { PhysicsComponent } from '../physics/PhysicsComponent';
import { BaseEntity } from './BaseEntity';

export const defaultRectParams = {
    x: 0,
    y: 0,
    r: 0,
    w: 100,
    h: 30,
    mass: 0,
    group: 0,
    mask: 0,
};

export type RectParams = typeof defaultRectParams;

export class RectEntity extends BaseEntity
{
    public params!: RectParams;
    public physics: PhysicsComponent;

    constructor()
    {
        super();
        this.physics = this.addComponent(PhysicsComponent);
    }

    public build(params: Partial<RectParams> = {}): void
    {
        this.physics.clearParts();
        this.params = { ...defaultRectParams, ...params };

        const body = PhysicsUtils.createBody({
            x: this.params.x,
            y: this.params.y,
            angle: this.params.r,
            mass: this.params.mass,
        }, {
            type: PhysicsShapeType.BOX,
            width: this.params.w,
            height: this.params.h,
            group: this.params.group,
            mask: this.params.mask,
        });

        this.physics.addParts(body);
    }
}
